import { render, staticRenderFns } from "./CustomerDetailView.vue?vue&type=template&id=a2c7efea&scoped=true"
import script from "./CustomerDetailView.vue?vue&type=script&lang=ts"
export * from "./CustomerDetailView.vue?vue&type=script&lang=ts"
import style0 from "./CustomerDetailView.vue?vue&type=style&index=0&id=a2c7efea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c7efea",
  null
  
)

export default component.exports